<div class="split-button" [ngStyle]="paddingStyle" [class.-active]="display">
  <div class="split-button-value" [class.-active]="display" [ngClass]="{ 'primary-color': textColor === 'primary' }">
    {{ value }}
  </div>
  <span class="fa fa-chevron-down arrow" *ngIf="!hideClose" [class.-active]="display"></span>
</div>

<div class="split-button-content" *ngIf="display">
  <div class="options" *ngFor="let option of options" (click)="select(option)">
    {{ option }}
  </div>
</div>
